import nexusClient from '@/apollo/nexusClient';
import { OPENAI_CHAT_PROXY_QUERY } from '@/services/graphql/nexus/programAutomation';

const generateScope = async (
  prompt: string,
  systemPrompt?: string,
  requesterId?: string
): Promise<string> => {
  try {
    const result = await nexusClient.query({
      query: OPENAI_CHAT_PROXY_QUERY,
      variables: {
        prompt,
        systemPrompt:
          systemPrompt || 'You are a helpful assistant that generates clear, concise responses.',
        model: 'gpt-4o-mini',
        temperature: 0.9,
        maxTokens: 60,
        requesterId
      },
      fetchPolicy: 'no-cache'
    });

    return result.data?.openAIChatProxy || '';
  } catch (error) {
    console.error('OpenAI Proxy Error:', error);
    throw error;
  }
};

// Export an object with all the functions
export default {
  generateScope
};
